import { render } from "./page-title.vue?vue&type=template&id=af51c96a&scoped=true"
import script from "./page-title.vue?vue&type=script&lang=ts"
export * from "./page-title.vue?vue&type=script&lang=ts"

import "./page-title.vue?vue&type=style&index=0&id=af51c96a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-af51c96a"

export default script